const config = {
  globals: {
    API_URL: process.env.VUE_APP_API
  }
}
export default config
